<template>
  <footer class="MainSiteFooter">
    <Container>
      <div class="columns">
        <div v-for="column, index in content.columns"
          :key="index"
          class="column"
        >
          <FooterMenu v-if="column.entries" class="footerMenu" :entries="column.entries" />
        </div>
      </div>
      <div v-if="content.badge" class="badge">
        <img :src="inseegoUsaBadgePng.src" :alt="content.badge.text" class="badgeImage" />
      </div>
      <div class="bottomBar">
        <RegionSelect class="regionSelect" :content="content.regionSelect" />
        <SocialLinks class="socialLinks" :items="content.socialLinks" />
      </div>
      <div class="copyrightBar">
        <CopyrightText :text="content.copyrightText" />
      </div>
    </Container>
  </footer>
</template>

<script setup>
import { inject } from 'vue'
import inseegoUsaBadgePng from './assets/inseego-usa-badge.png'
import CopyrightText from './CopyrightText.vue'
import FooterMenu from './FooterMenu.vue'
import RegionSelect from './RegionSelect.vue'
import SocialLinks from './SocialLinks.vue'
import contentAllLocales from './content.json'
const locale = inject('locale')
const content = contentAllLocales[locale]
</script>

<style scoped>
.MainSiteFooter {
  --text-color-intense: white;
  --text-color-muted: #90AFCE;
  --hairline-color: #0C3362;
  padding-top: var(--spacing-14);
  padding-bottom: var(--spacing-13);
  background-color: #08192E;
  font-size: 0.825rem;
}

.column.hidden-on-mobile {
  display: none;
}

.column:not(.column.hidden-on-mobile) + .column {
  margin-top: var(--spacing-10);
  border-top: thin solid var(--hairline-color);
  padding-top: var(--spacing-10);
}

.footerMenu {
  font-weight: 400;
  color: var(--text-color-intense);
}

.column:last-child .footerMenu {
  color: var(--text-color-muted);
}

.badgeImage {
  width: 99px;
}

.columns + .bottomBar {
  margin-top: var(--spacing-12);
}

.columns + .badge {
  margin-top: var(--spacing-8);
}

.badge + .bottomBar {
  margin-top: var(--spacing-8);
}

.bottomBar {
  border-width: thin;
  border-style: solid none;
  border-color: var(--hairline-color);
  padding-top: var(--spacing-15);
  padding-bottom: var(--spacing-12);
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: var(--spacing-12);
}

.bottomBar + .copyrightBar {
  margin-top: var(--spacing-12);
}

.copyrightBar {
  text-align: center;
}

@media (--screen-md) {
  .columns {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing-10) var(--spacing-7);
  }

  .column.hidden-on-mobile {
    display: block;
  }

  .column:not(.column.hidden-on-mobile) + .column {
    margin-top: 0;
    border-style: none;
    padding-top: 0;
  }

  .columns + .badge {
    margin-top: 0;
  }

  .badgeImage {
    margin-left: auto;
  }

  .bottomBar {
    padding-top: var(--spacing-6);
    padding-bottom: var(--spacing-6);
    flex-direction: row;
    justify-content: space-between;
    row-gap: var(--spacing-6);
  }

  .bottomBar + .copyrightBar {
    margin-top: var(--spacing-9);
  }

  .copyrightBar {
    text-align: left;
  }
}

@media (--screen-lg) {
  .columns {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
